import React from "react";
import {useTranslation} from "react-i18next";
import FeatherIcon from "feather-icons-react";

const EmptyData = ({title = '', text= '', actionLabel, onAction}) => {
    const { t } = useTranslation();

    return (
        <div className="empty">
            <center>
                <FeatherIcon icon="folder"/>
                <br/>
                    {title ? t(title) : t("Empty data")}
                <p>
                    { text ? t(text) : "Default text"}
                </p>
                {onAction && (
                    <a
                        href="#"
                        className="empty-action-link"
                        onClick={(e) => { e.preventDefault(); onAction(); }}
                    >
                        {actionLabel ? t(actionLabel) : t("Settings")}
                    </a>
                )}
            </center>
        </div>
    )
}

export default EmptyData
